import { getErrorMessage } from '@/lib/errors'
import { supabase } from '@/lib/supabase'
import { useEffect, useState } from 'react'

interface CheckoutState {
  loading: boolean
  error: string | null
}

export function useCheckout() {
  const [state, setState] = useState<CheckoutState>({ loading: false, error: null })

  // When the user navigates back from Stripe (bfcache restore), reset loading state
  useEffect(() => {
    function handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        setState((s) => (s.loading ? { loading: false, error: null } : s))
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [])

  async function startCheckout(priceId: string) {
    setState({ loading: true, error: null })

    const origin = window.location.origin
    const { data, error } = await supabase.functions.invoke('create-checkout-session', {
      body: {
        priceId,
        successUrl: `${origin}/dashboard?upgraded=1`,
        cancelUrl: `${origin}/settings`,
      },
    })

    if (error || !data?.url) {
      setState({ loading: false, error: getErrorMessage('INTERNAL_ERROR') })
      return
    }

    window.location.href = data.url as string
  }

  return { ...state, startCheckout }
}
